"use client";

import { useState } from "react";
import { FullReport } from "@/components/residency-map/full-report";
import { cn } from "@/lib/utils";
import { StarIcon } from "lucide-react";

export const PreviewReport = ({
  report,
  facilitySlug,
  unitSlug,
}: {
  report: MedicalFacilityUnitReport;
  facilitySlug: string;
  unitSlug: string;
}) => {
  const { details, anonTitle, rating, createdAt } = report;
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <>
      <div
        className={cn(
          "border-sm active:98 min-w-[290px] rounded-lg border p-4 transition-all hover:cursor-pointer @max-[640px]:my-1",
          "md:p-6",
        )}
        onClick={() => setIsOpenModal(true)}
      >
        <div className={"mb-1 text-sm font-medium text-zinc-950"}>
          {details.specialization.title}
        </div>
        <div className={"mb-6 text-xs font-normal text-zinc-500"}>
          {anonTitle}
        </div>

        <div className={"mb-2 flex items-center justify-between"}>
          <div className={"text-2xl font-bold text-zinc-950"}>
            {rating.toFixed(1)}
          </div>
          <div className={"flex items-center justify-start gap-1"}>
            {Array.from({ length: rating }).map((_, i) => (
              <StarIcon
                fill={"#FE9C08"}
                stroke={"#FE9C08"}
                size={"20px"}
                key={i}
              />
            ))}
            {Array.from({ length: 5 - rating }).map((_, i) => (
              <StarIcon stroke={"#FE9C08"} size={"20px"} key={i} />
            ))}
          </div>
        </div>
        <div className={"text-xs font-normal text-zinc-500"}>{createdAt}</div>
      </div>
      <FullReport
        isOpenModal={isOpenModal}
        setIsOpenModal={setIsOpenModal}
        report={report}
        facilitySlug={facilitySlug}
        unitSlug={unitSlug}
      />
    </>
  );
};
